import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';

import { sortBy } from 'lodash'

import { ApiServiceServerless } from '../../../xhr_libs';
import AddEntityActionButtons from '../../forms/AddEntityActionButtons';

export default function ClonePlugCustomTemplateModal(props) {
  const {
    show,
    onHide,
    showToast,
    templates,
    setTemplates,
    setActiveTemplateId,
    organizationId,
  } = props;

  const [templateName, setTemplateName] = useState('');
  const [cloneTemplateId, setCloneTemplateId] = useState('');

  const [disabled, setDisabled] = useState(true);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (templateName && cloneTemplateId) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [templateName, cloneTemplateId]);

  const cloneTemplate = (e) => {
    e.preventDefault();
    setIsLoading(true);
    ApiServiceServerless.post(
      `/custom_templates/clone/${cloneTemplateId}`,
      {
        name: templateName,
      },
      { authorization_id: organizationId }
    )
      .then((res) => {
        setTemplates((prev) => [...prev, res.data]);
        setActiveTemplateId(res.data.id);
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        throw error;
      })
      .finally(() => {
        onHide();
        setIsLoading(false);
        resetModal();
      });
  };

  const resetModal = () => {
    setTemplateName('');
    setCloneTemplateId('');
  };

  useEffect(() => {
    if (show) {
      resetModal();
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>Clone Template</Modal.Header>
      <Form onSubmit={cloneTemplate}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>
              {'Template Name'}
              <span className='text-warning font-weight-bold pl-1'>*</span>
            </Form.Label>
            <Form.Row>
              <Form.Control
                required
                placeholder=''
                onChange={(e) => setTemplateName(e.target.value)}
              />
            </Form.Row>
          </Form.Group>
          <Form.Group>
            <Form.Label>
              Template To Clone
              <span className='text-warning font-weight-bold pl-1'>*</span>
            </Form.Label>

            <Form.Control
              as='select'
              required
              onChange={(e) => {
                setCloneTemplateId(parseInt(e.target.value));
              }}
            >
              <option key={'opt-null'} value={''} hidden>
                -
              </option>
              {templates.length === 0 && (
                <option key={'null-null'} value={''} disabled>
                  No existing templates
                </option>
              )}
              {sortBy(templates, ['name']).map((template) => (
                <option key={'opt-' + template.id} value={template.id}>
                  {template.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <AddEntityActionButtons
            onCancel={onHide}
            submitDisabled={disabled}
            isSubmitting={isLoading}
          />
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
